export const WHATSAPP_OPTIONS_KEY = 'whatsapp_options';
export const WHATSAPP_ACCOUNT_KEY = 'whatsapp_account';

export const DEFAULT_WHATSAPP_ACCOUNT = {
  phone_number_id: '',
  access_token: '',
  api_version: '',
  waba_id: '',
  has_access_token: false,
  configured: false,
};

export function mergeWhatsappAccountSettings(account) {
  const incoming = account && typeof account === 'object' ? account : {};
  return {
    ...DEFAULT_WHATSAPP_ACCOUNT,
    phone_number_id: incoming.phone_number_id || '',
    access_token: incoming.access_token || '',
    api_version: incoming.api_version || '',
    waba_id: incoming.waba_id || '',
    has_access_token: Boolean(incoming.has_access_token || incoming.access_token),
    configured: Boolean(
      incoming.configured
      || (incoming.phone_number_id && (incoming.has_access_token || incoming.access_token))
    ),
  };
}

export function isWhatsappAccountReady(account) {
  const phone = (account?.phone_number_id || '').trim();
  const token = (account?.access_token || '').trim();
  return Boolean(phone && (token || account?.has_access_token));
}

export const DEFAULT_WHATSAPP_NOTIFICATION_SETTINGS = {
  booking: {
    sender: true,
    receiver: true,
    invoice_to_sender: true,
    invoice_to_receiver: true,
  },
  dispatch: {
    sender: false,
    receiver: false,
    send_ml_sheet_to_access_users: false,
    send_ml_sheet_text_to_access_users: false,
  },
  received: {
    sender: false,
    receiver: true,
  },
  delivered: {
    sender: true,
    receiver: true,
    invoice_to_sender: true,
    invoice_to_receiver: true,
  },
  delivery_otp: {
    enabled: false,
    sender: false,
    receiver: true,
    template_name: '',
  },
  daily_summary: {
    enabled: true,
  },
};

export const WHATSAPP_EVENT_META = [
  {
    key: 'booking',
    label: 'Booking',
    hint: 'Utility without invoice · Marketing + PDF when invoice is on for that party',
    options: [
      { key: 'sender', label: 'Sender' },
      { key: 'receiver', label: 'Receiver' },
      { key: 'invoice_to_sender', label: 'Invoice PDF to sender' },
      { key: 'invoice_to_receiver', label: 'Invoice PDF to receiver' },
    ],
  },
  {
    key: 'dispatch',
    label: 'Dispatch',
    hint: 'Utility only — no invoice on dispatch. ML sheet alerts go to access users.',
    options: [
      { key: 'sender', label: 'Sender' },
      { key: 'receiver', label: 'Receiver' },
      {
        key: 'send_ml_sheet_to_access_users',
        label: 'Send ML sheet PDF to access users (Marketing template + document)',
      },
      {
        key: 'send_ml_sheet_text_to_access_users',
        label: 'Send ML sheet alert to access users without PDF (text template)',
      },
    ],
  },
  {
    key: 'received',
    label: 'Received',
    hint: 'Utility only — no invoice attachment',
    options: [
      { key: 'sender', label: 'Sender' },
      { key: 'receiver', label: 'Receiver' },
    ],
  },
  {
    key: 'delivered',
    label: 'Delivered',
    hint: 'Utility without invoice · Marketing + PDF when invoice is on for that party',
    options: [
      { key: 'sender', label: 'Sender' },
      { key: 'receiver', label: 'Receiver' },
      { key: 'invoice_to_sender', label: 'Invoice PDF to sender' },
      { key: 'invoice_to_receiver', label: 'Invoice PDF to receiver' },
    ],
  },
  {
    key: 'delivery_otp',
    label: 'Delivery OTP verification',
    hint: 'Send a WhatsApp OTP before Delivered. After verify, the shipment is auto-delivered. Off for existing companies until you enable it.',
    options: [
      { key: 'enabled', label: 'Require OTP before delivery' },
      { key: 'receiver', label: 'Send OTP to receiver' },
      { key: 'sender', label: 'Send OTP to sender' },
    ],
  },
  {
    key: 'daily_summary',
    label: 'Daily business summary',
    hint: 'Midnight WhatsApp to company contact using this company Meta account only.',
    options: [
      { key: 'enabled', label: 'Send daily business summary (dq_daily_business_summary)' },
    ],
  },
];

export function mergeWhatsappNotificationSettings(settings) {
  const merged = {};
  Object.keys(DEFAULT_WHATSAPP_NOTIFICATION_SETTINGS).forEach((event) => {
    const defaults = DEFAULT_WHATSAPP_NOTIFICATION_SETTINGS[event];
    const incoming = settings?.[event] || {};
    merged[event] = { ...defaults };

    if (
      (event === 'booking' || event === 'delivered') &&
      Object.prototype.hasOwnProperty.call(incoming, 'with_invoice')
    ) {
      const legacy = Boolean(incoming.with_invoice);
      if (!Object.prototype.hasOwnProperty.call(incoming, 'invoice_to_sender')) {
        merged[event].invoice_to_sender = legacy;
      }
      if (!Object.prototype.hasOwnProperty.call(incoming, 'invoice_to_receiver')) {
        merged[event].invoice_to_receiver = legacy;
      }
    }

    Object.keys(defaults).forEach((key) => {
      if (Object.prototype.hasOwnProperty.call(incoming, key)) {
        merged[event][key] =
          typeof defaults[key] === 'boolean'
            ? Boolean(incoming[key])
            : incoming[key] ?? defaults[key];
      }
    });
  });
  return merged;
}
